export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const PHONE_REGEX =
  /^(\+\d{1,2}\s?)?\(?[2-9]\d{2}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const REQUIRED_FIELD_MESSAGE = 'This is a required field';
export const FULL_NAME_ERROR_MESSAGE = 'Please enter your full name';
export const INCORRECT_FORMAT_MESSAGE = (fieldName: string) =>
  `Please enter a valid ${fieldName}`;
